import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const validatePromoCode = async (promoData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/promos/validate", promoData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllExpenses = async (
  businessId?: string,
  venueId?: string | null
): Promise<any> => {
  try {
    const uid = getUserId();
    const isAll = !businessId || String(businessId).toLowerCase() === "all";
    const url = isAll
      ? (() => {
          if (!venueId) {
            throw new Error("Venue ID is required to view all expenses");
          }
          return `/expenses/view-all/${venueId}`;
        })()
      : `/expenses/view/${businessId}`;
    const payload = uid ? { user_id: uid } : {};
    const response = await apiClient.post(url, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllOwnerExpenses = async (
  adminId?: string | null
): Promise<any> => {
  try {
    const id = adminId || getUserId();
    if (!id) {
      throw new Error("Admin ID is required to fetch owner expenses");
    }
    const response = await apiClient.get(
      `/expenses/getAdminExpenses/owner/${id}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export interface CreateExpenseInput {
  amount?: string | number;
  business_id?: string;
  created_at?: string;
  description?: string;
  notes?: string;
  title?: string;
  user_id?: string;
  [key: string]: any;
}

export const createExpense = async (
  expenseData: CreateExpenseInput
): Promise<any> => {
  try {
    const uid = expenseData.user_id ?? getUserId();

    const payload = {
      amount: expenseData.amount ?? "",
      business_id: expenseData.business_id ?? "",
      created_at: expenseData.created_at ?? new Date().toISOString(),
      description: expenseData.description ?? "",
      notes: expenseData.notes ?? "",
      title: expenseData.title ?? "",
      user_id: uid ?? "",
    } as Record<string, any>;

    const response = await apiClient.post("/expenses/add", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateExpense = async (
  id: string,
  expenseData: CreateExpenseInput
): Promise<any> => {
  try {
    const response = await apiClient.put(`/expenses/edit/${id}`, expenseData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteExpense = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/expenses/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
